import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from '@app/_services/request.service';
import { authorityIds, operations, subAuthorities } from '@app/enums';

@Injectable({ providedIn: 'root' })
export class StrategyApiService {
  constructor(private REQ: RequestService) {}

  getStrategyList(): Observable<any> {
    const qry = {
      params: {},
      user_data: {
        authority: authorityIds.OSMA_STRATEGY,
        sub_authority: subAuthorities.STRATEGY.LIST,
        operation: operations.LIST,
        data: 'NA',
        format: 'json',
      },
    };
    return this.REQ.get('osma/strategy', { query: JSON.stringify(qry) });
  }
}
